module.exports = __webpack_public_path__ + "img/4clubs.53247c71.jpg";